import { Button } from "@/components/ui/button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { Label } from "@/components/ui/label"
import { Switch } from "@/components/ui/switch"
import { CheckCircledIcon, CrossCircledIcon } from "@radix-ui/react-icons"
import React, { useState } from "react"

type EditBooleanFieldModalProps = {
  isOpen: boolean
  fieldName: string
  fieldDescription?: string
  currentValue: boolean
  onSave: (newValue: boolean) => void
  onClose: () => void
}

export const EditBooleanFieldModal: React.FC<EditBooleanFieldModalProps> = ({
  isOpen,
  fieldName,
  fieldDescription,
  currentValue,
  onSave,
  onClose,
}) => {
  const [value, setValue] = useState<boolean>(currentValue)

  const handleSave = () => {
    onSave(value)
  }

  return (
    <Dialog open={isOpen} onOpenChange={(open: boolean) => !open && onClose()}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Modifier {fieldName}</DialogTitle>
          <DialogDescription>
            {fieldDescription ||
              `Activez ou désactivez ${fieldName.toLowerCase()}.`}
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-6">
          {/* Affichage de l'état actuel */}
          <div className="space-y-3">
            <Label>État actuel</Label>
            <div className="flex items-center space-x-3 p-3 border border-slate-200 dark:border-slate-700 rounded-md bg-slate-50 dark:bg-slate-800/50">
              {currentValue ? (
                <div className="flex items-center text-green-600 dark:text-green-400">
                  <CheckCircledIcon className="h-5 w-5 mr-2" />
                  <span className="font-medium">Activé</span>
                </div>
              ) : (
                <div className="flex items-center text-red-600 dark:text-red-400">
                  <CrossCircledIcon className="h-5 w-5 mr-2" />
                  <span className="font-medium">Désactivé</span>
                </div>
              )}
            </div>
          </div>

          {/* Contrôle pour modifier la valeur */}
          <div className="space-y-3">
            <Label htmlFor="booleanSwitch">Nouveau paramètre</Label>
            <div className="flex items-center space-x-3 p-3 border border-slate-200 dark:border-slate-700 rounded-md">
              <Switch
                id="booleanSwitch"
                checked={value}
                onCheckedChange={setValue}
              />
              <div className="flex items-center">
                {value ? (
                  <div className="flex items-center text-green-600 dark:text-green-400">
                    <CheckCircledIcon className="h-5 w-5 mr-2" />
                    <span className="font-medium">Activé</span>
                  </div>
                ) : (
                  <div className="flex items-center text-red-600 dark:text-red-400">
                    <CrossCircledIcon className="h-5 w-5 mr-2" />
                    <span className="font-medium">Désactivé</span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <DialogFooter className="sm:justify-start pt-4">
          <Button type="button" variant="outline" onClick={onClose}>
            Annuler
          </Button>
          <Button type="button" onClick={handleSave}>
            Sauvegarder les modifications
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
